define.alias("shared/components/shared/social/linkedin-modal", "media/components/shared/social/linkedin-modal");